import Banner from "../layout/Banner";
import { Footer } from "../landing/Footer";
import TopNavbar from "../landing/TopNavbar";
import CallToAction from "../layout/CallToAction";
import getButtonStyle from "../../utils/styles";
import { getSolidIcon } from "../../utils/icons";

const hospitalityData = [
  {
    header: "Boost revenue",
    subheader: "Increase sales, repeat customers & loyalty",
    image: "/img/graphics/screenshots/campaigns.svg",
    firstText:
      "Our platform gives you the power to proactively engage with your customers in a personalised way to keep them coming back.",
    secondText:
      "In a non-intrusive way, you can subtly encourage customers to purchase promoted products, redeem offers, sign up to newsletters, make bookings and much more.",
    bullets: [
      {
        icon: getSolidIcon("credit-card", "info", 5, "mt-1 flex-none"),
        bold: "Instant sales. ",
        text: "Customers can make purchases and complete payments using their voice or a few simple touch commands. Pay-by-Voice is here.",
      },
      {
        icon: getSolidIcon("gift", "info", 5, "mt-1 flex-none"),
        bold: "Personalised marketing. ",
        text: "Create hyper-personalised or segmented visual campaigns to encourage interaction, promote temporal deals or provide special one time offers.",
      },
      {
        icon: getSolidIcon("heart", "info", 5, "mt-1 flex-none"),
        bold: "Die-hard loyalty. ",
        text: "Our one-of-a-kind digital loyalty system has customers coming back whilst allowing them to take their profile anywhere.",
      },
    ],
    thirdText:
      "Our platform puts you in control. Take the guess work out of knowing what your customers want and when they want it. We provide granular information on customer behaviour and preferences so you can make informed decisions.",
    challenge: {
      title: "Need some ideas?",
      text: "No problem. We have a team of experts that can help craft the end-user experience customised for your needs. We also have a library of templates to use that can get you started instantly!",
    },
    action: {
      text: "We're ready to help you straight away.",
      url: "https://audico.co.uk/contact",
      subtext: "Get in touch",
    },
  },
  {
    header: "Optimise operations",
    subheader: "Improve operational effiency",
    image: "/img/graphics/screenshots/analytics.svg",
    firstText:
      "We believe in making best use of what you have available. Our platform provides a cost effective way to optimise your business and workforce without having to splash out.",
    secondText:
      "Our system is designed to work in harmony with staff members and to give them superpowers. It takes a matter of minutes to become an expert and is so intuitive that it can be used by anyone.",
    bullets: [
      {
        icon: getSolidIcon("rocket", "info", 5, "mt-1 flex-none"),
        bold: "Increase productivity. ",
        text: "Satisfying customers can be extremely manual. Allow us to automate and accelerate the overall customer journey from ordering, to fulfillment, to payment.",
      },
      {
        icon: getSolidIcon("chart-bar", "info", 5, "mt-1 flex-none"),
        bold: "Be proactive. ",
        text: "Rather than always being on the back foot, use proactive prompts & features and know exactly what someone wants when they make a request.",
      },
      {
        icon: getSolidIcon("light", "info", 5, "mt-1 flex-none"),
        bold: "Real time insights. ",
        text: "Stay informed if you're on the go or at your computer. Access insights and recommendations in real time powered by AI to help you run smarter.",
      },
    ],
    thirdText:
      "Our platform is proven to reduce journey time for staff members, increase productivity and provide insights to promote optimised operations.",
    challenge: {
      title: "Not technical? No problem",
      text: "Our platform was built from the ground up with intuition in mind. Our UI is clean, non-cluttered and everything has human-readable explanations, even our AI!",
    },
    action: {
      text: "We're ready to help you straight away.",
      url: "https://audico.co.uk/contact",
      subtext: "Get in touch",
    },
  },
  {
    header: "Reduce costs",
    subheader: "Save significant money & time",
    image: "/img/graphics/screenshots/log.svg",
    firstText:
      "Why pay over the odds and be locked in to a lifetime commitment? Our platform is cost-effective and our hardware doesn't need to be replaced every year.",
    secondText:
      "Our flexible pricing means that you pay for what you use. Furthermore, the more you use the lower the cost.",
    bullets: [
      {
        icon: getSolidIcon("stack", "info", 5, "mt-1 flex-none"),
        bold: "Consolidate hardware. ",
        text: "Why buy 5 to 10 different systems to manage individual things when ours can cover it all?",
      },
      {
        icon: getSolidIcon("receipt-pct", "info", 5, "mt-1 flex-none"),
        bold: "Reduce cost. ",
        text: "Not only is our system multi-purpose, but it is cost-effective too with a one-time fee for hardware and flexible monthly payments for the software.",
      },
      {
        icon: getSolidIcon(
          "chart-presentation-line",
          "info",
          5,
          "mt-1 flex-none",
        ),
        bold: "Long term value. ",
        text: "Our software receives fortnightly updates so it's always improving! Our hardware is proven to last for years, even the very first release still works today!",
      },
    ],
    thirdText:
      "Whether it's our hardware, software or services we provide cost-effective solutions that can be tailored to your needs.",
    challenge: {
      title: "Not ready yet? Take a look first",
      text: "We're so confident of our platform and we'd love to show it to you. Get in touch to organise a demo and to discuss a pilot.",
    },
    action: {
      text: "We're ready to help you straight away.",
      url: "https://audico.co.uk/contact",
      subtext: "Get in touch",
    },
  },
];

// const healthData = [
//   {
//     header: "Boost independence",
//     subheader: "Give control back to your residents",
//     image: "/img/graphics/screenshots/surveys.svg",
//     firstText: "As we grow older the simple things become more difficult. Giving control back to residents in any way possible is a sure fire way to boost their esteem.",
//     secondText: "It may seem small, but being able to control the lights, log a maintenance issue, remind themselves of their schedule or take their medication on time can make a huge difference to someone's day.",
//     bullets: [
//       {
//         icon: getSolidIcon("smile", "info", 5, "mt-1 flex-none"),
//         bold: "Improved self esteem. ",
//         text: "Empowering residents to do things independently makes them feel on top of the world."
//       },
//       {
//         icon: getSolidIcon("gift", "info", 5, "mt-1 flex-none"),
//         bold: "Happier, healthier life. ",
//         text: "Our ambient technology is there to assist and enhance the lives of residents, not intrude."
//       },
//       {
//         icon: getSolidIcon("heart", "info", 5, "mt-1 flex-none"),
//         bold: "Empowering individuals. ",
//         text: "We find that once they start they don't want to stop using it and are incredibly curious explore the possibilities."
//       }
//     ],
//     thirdText: "We recognise that managing in a care environment is unbelievably tough. Let our easy-to-use platform take some of the stress away from staff whilst helping residents to life happier, healthier lives.",
//     challenge: {
//       title: "Not sure where to start?",
//       text: "Don't worry, We have a team of experts that can offer suggestions on how to engage with residents through our technology and we have a library of templates to use that can get you started instantly!"
//     },
//     action: {
//       text: "We're ready to help you straight away.",
//       url: "https://audico.co.uk/contact",
//       subtext: "Get in touch"
//     }
//   },
//   {
//     header: "Optimise operations",
//     subheader: "Improve operational effiency",
//     image: "/img/graphics/screenshots/feed.svg",
//     firstText: "We believe in making best use of what you have available. Our platform provides a cost effective way to optimise your workforce without having to splash out.",
//     secondText: "Our system is designed to work in harmony with staff members and carers. It takes a matter of minutes to become an expert and is so intuitive that it can be used by anyone.",
//     bullets: [
//       {
//         icon: getSolidIcon("rocket", "info", 5, "mt-1 flex-none"),
//         bold: "Increase productivity. ",
//         text: "Fulfilling requests around a property can be extremely time-consuming, especially if you don't know in advance what they want. Our platform gives your foresight and allows a place to manage everything."
//       },
//       {
//         icon: getSolidIcon("chart-bar", "info", 5, "mt-1 flex-none"),
//         bold: "Be proactive. ",
//         text: "Rather than waiting until something needs to be done, use proactive prompts & features and know give an extra touch of personalisation to your service."
//       },
//       {
//         icon: getSolidIcon("light", "info", 5, "mt-1 flex-none"),
//         bold: "Real time insights. ",
//         text: "Stay informed if you're on the go or at your computer. Access insights and recommendations in real time powered by AI to help you run smarter."
//       }
//     ],
//     thirdText: "Our platform is proven to reduce journeys for staff members, increase productivity and provide insights to promote optimised operations.",
//     challenge: {
//       title: "Not technical? No problem",
//       text: "Our platform was built from the ground up with intuition in mind. Our UI is clean, non-cluttered and everything has human-readable explanations, even our AI!"
//     },
//     action: {
//       text: "Still have questions?",
//       url: "https://audico.co.uk/contact",
//       subtext: "Ask us anything"
//     }
//   },
//   {
//     header: "Reduce costs",
//     subheader: "Save significant money & time",
//     image: "/img/graphics/screenshots/analytics.svg",
//     firstText: "Why pay over the odds and be locked in to a lifetime commitment? Our platform is cost-effective and our hardware doesn't need to be replaced every year.",
//     secondText: "Our flexible pricing means that you pay for what you use. Furthermore, the more you use the lower the cost.",
//     bullets: [
//       {
//         icon: getSolidIcon("stack", "info", 5, "mt-1 flex-none"),
//         bold: "Consolidate hardware. ",
//         text: "Why buy 5 to 10 different systems to manage individual things when ours can cover it all?"
//       },
//       {
//         icon: getSolidIcon("receipt-pct", "info", 5, "mt-1 flex-none"),
//         bold: "Reduce cost. ",
//         text: "Not only is our system multi-purpose, but it is cost-effective too with a one-time fee for hardware and flexible monthly payments for the software."
//       },
//       {
//         icon: getSolidIcon("chart-presentation-line", "info", 5, "mt-1 flex-none"),
//         bold: "Long term value. ",
//         text: "Our software receives fortnightly updates so it's always improving! Our hardware is proven to last for years, even the very first release still works today!"
//       }
//     ],
//     thirdText: "Whether it's our hardware, software or services we provide cost-effective solutions that can be tailored to your needs.",
//     challenge: {
//       title: "Not ready yet? Take a look first",
//       text: "We're so confident of our platform and we'd love to show it to you. Get in touch to organise a demo and to discuss a pilot."
//     },
//     action: {
//       text: "Would you like to see a demo?",
//       url: "https://audico.co.uk/contact",
//       subtext: "Book time with our experts"
//     }
//   },
// ]

export default function Proposition() {
  return (
    <div className="bg-midnight">
      <TopNavbar />

      {/* Value proposition for Health */}
      <div className="relative isolate overflow-hidden px-6 lg:overflow-visible lg:px-0">
        {hospitalityData.map((value, index) => (
          <div
            key={index}
            id="Hospitality-section"
            className={`mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10 pb-10 lg:pb-32 pt-36`}
          >
            {/* Header */}
            <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
              <div className="lg:pr-4">
                <div className="lg:max-w-lg">
                  <p className="text-base font-semibold leading-7 text-info">
                    {value.header}
                  </p>
                  <h1 className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                    {value.subheader}
                  </h1>
                  <p className="mt-6 text-xl leading-8 text-light">
                    {value.firstText}
                  </p>
                </div>
              </div>
            </div>

            {/* Image */}
            <div className="-ml-12 -mt-12 p-12 lg:sticky lg:top-20 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
              <img
                className="w-[48rem] max-w-none rounded-xl shadow-xl outline outline-secondary shadow-zinc-100/10 sm:w-[57rem]"
                src={value.image}
                alt=""
              />
            </div>

            {/* Text content */}
            <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
              <div className="lg:pr-4">
                <div className="max-w-xl text-base leading-7 text-light lg:max-w-lg">
                  <p>{value.secondText}</p>
                  <ul className="mt-8 space-y-8 text-light">
                    {value.bullets.map((bullet, idx) => (
                      <li className="flex gap-x-3" key={idx}>
                        {bullet.icon}
                        <span>
                          <strong className="font-semibold text-white">
                            {bullet.bold}
                          </strong>
                          {bullet.text}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <p className="mt-8">{value.thirdText}</p>
                  <h2 className="mt-16 text-2xl font-bold tracking-tight text-white">
                    {value.challenge.title}
                  </h2>
                  <p className="mt-6">{value.challenge.text}</p>
                </div>
                <div className="hidden mt-8 sm:flex justify-start">
                  <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-white ring-1 ring-secondary/30 hover:ring-light">
                    {value.action.text}{" "}
                    <a
                      href={value.action.url}
                      className="font-semibold text-primary"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="absolute inset-0" aria-hidden="true" />
                      {value.action.subtext}{" "}
                      <span aria-hidden="true">&rarr;</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Call to action */}
      <CallToAction bgColour="bg-midnight">
        <div className="mx-auto max-w-xl lg:max-w-3xl text-center">
          <h2 className="font-display tracking-tight text-primarygotham-bold text-3xl sm:text-4xl md:text-5xl gotham-bold text-primary">
            Does it sound appealing to you?
          </h2>
          <p className="mt-4 text-lg tracking-tight text-slate-200">
            We'd love to help you realise these benefits and more. Our friendly
            team of experts are ready and waiting at your service!
          </p>
          <a
            className={`${getButtonStyle("solid", "info")} mt-10`}
            href="https://audico.co.uk/contact"
            target="_blank"
            rel="noreferrer"
          >
            Get in touch
          </a>
        </div>
      </CallToAction>

      {/* Footer */}
      <Footer />

      {/* Alert banner */}
      <Banner />
    </div>
  );
}
